// extracted by mini-css-extract-plugin
export default {"link":"Nav_link__xnOem","footer":"Nav_footer__mR9u0","list":"Nav_list__7SvBE"};